import { SxProps, Theme } from "@mui/system";

export const SkeletonPropsStyleGenerator = (width: string | number, height: string | number): SxProps<Theme> => {
  return {
    width,
    height,
  };
};
